import React from "react";
import CustomCard from "../../shared/Card/CustomCard";
import StyleGuideForm from "./StyleGuideForm";

export default function EditStyleGuide({ name }) {
    return (
        <CustomCard title={name}>
            <StyleGuideForm type="EDIT" />
        </CustomCard>
    );
}
